import type {
  PostProductCartProps,
  RemoveProductCartProps
} from "./productItem.types";

export async function postProductCart({
  orderFormId,
  products
}: PostProductCartProps) {
  const orderItems = products.map((product) => ({
    seller: product.seller,
    quantity: product.quantity,
    id: product.id
  }));

  let updatedCart = { orderItems };

  try {
    const response = await fetch(
      `${process.env.BASE_API_URL}checkout/cart/${orderFormId}/items`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(updatedCart)
      }
    );

    if (!response.ok) {
      throw new Error(
        `Erro ao adicionar produto ao carrinho: ${response.status} ${response.statusText}`
      );
    }

    const data = await response.json();
    return data;
  } catch (error: unknown) {
    console.error("Erro em postProductCart:", error);
  }
}

export async function removeProductCart({
  orderFormId,
  sellerId,
  sku,
  quantity,
  index
}: RemoveProductCartProps) {
  const newProduct = [
    {
      seller: sellerId,
      id: sku,
      quantity,
      index
    }
  ];

  let updatedCart = { orderItems: newProduct };

  try {
    const response = await fetch(
      `${process.env.APP_API_URL}checkout/cart/${orderFormId}/items`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(updatedCart)
      }
    );

    if (!response.ok) {
      throw new Error(
        `Erro ao remover produto do carrinho: ${response.status} ${response.statusText}`
      );
    }

    const data = await response.json();
    return data;
  } catch (error: unknown) {
    console.error("Erro em removeProductCart:", error);
  }
}
